export default {"src":"/_next/static/media/youtube.d5ed9f90.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};